module.exports = __webpack_public_path__ + "static/Ubuntu-Medium-8e22c2a6e3a3c679787e763a97fa11f7.ttf";